import React from 'react';
import { Modal } from 'react-bootstrap'
import { Button, ValidationError } from 'fw/components';
import { MaskedBox, Form } from 'fw/forms';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from 'layouts/public/loading/Loading'
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications';

class ModalAuthentication extends React.Component {
    onClose = null;

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            loaded: false,
            error: null,
            form: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ visible: nextProps.visible });
    }

    open = (userId, onClose) => {
        this.setState({
            userId
        }, () => {
            this.onClose = onClose;
            this.retrieveAuthenticationInfo();
        });
    }

    close = () => {
        this.setState({ visible: false, loaded: false }, () => {
            this.onClose && this.onClose();
            this.onClose = null;
        });
    }

    handleFormChange = (form) => {
        this.setState({ form });
    }

    handleResend = () => {
        this.resendVerificationCode();
    }

    handleVerify = () => {
        this.verifyAuthentication();
    }

    handleTryAgain = () => {
        this.setState({
            loaded: false,
            error: null
        }, () => this.retrieveAuthenticationInfo());
    }

    retrieveAuthenticationInfo = () => {
        const rq = {
            userId: this.state.userId
        };

       API.Security.get('/authentication/retrieveAuthenticationInfo', rq,
            {
                success: (sr) => {
                    if (!sr.data.mustAuthenticate)
                        this.close();
                    else
                        this.setState({
                            visible: true,
                            loaded: true,
                            data: sr.data,
                            form: {
                                verificationCode: ""
                            }
                        });
                },
                error: (sr) => {
                    this.setState({
                        visible: true,
                        loaded: true,
                        error: sr.error
                    });
                }
            },
            { block: false });
    }

    resendVerificationCode = () => {
        const rq = {
            userId: this.state.userId,
        };

        API.Security.post('/authentication/resendVerificationCode', rq,
            {
                success: (sr) => {
                    Notifications.success(sr.message);
                },
                error: (sr) => {
                    Notifications.error(sr.error.errorMessage);
                }
            },
            { block: false });
    }

    verifyAuthentication = () => {
        const rq = {
            userId: this.state.userId,
            verificationCode: this.state.form.verificationCode
        };

        API.Security.post('/authentication/verifyAuthentication', rq,
            {
                success: (sr) => {
                    this.close();
                    Notifications.success(sr.message);
                },
                error: (sr) => {
                    Notifications.error(sr.error.errorMessage);
                }
            },
            { block: false });
    }

    renderBody = () => {
        if (!this.state.loaded)
            return (<Loading />)
        else if (this.state.error)
            return <ValidationError error={this.state.error} enableTryAgain onTryAgain={this.handleTryAgain} />

        else if (this.state.loaded) {
            const data = this.state.data;

            return (
                <React.Fragment>
                    <p>{data.firstName} we texted your phone {data.phoneNumber}. Please enter the code received to continue.</p>
                    <MaskedBox name="verificationCode" mask="999999" placeholder="Code" />
                    <br />
                    <Button id="btnSendEmail" onClick={this.handleResend}>
                        Resend code <FontAwesomeIcon style={{ marginLeft: "4px" }} icon={faRedo} />
                    </Button>
                </React.Fragment>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    show={this.state.visible}
                    backdrop="static"
                    dialogClassName="small-modal">
                    <Form
                        onSubmit={this.handleVerify}
                        values={this.state.form}
                        onChange={this.handleFormChange}>
                        <Modal.Header>
                            <Modal.Title>Enter code</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.renderBody()}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button id="btnVerify" type="submit" bsStyle="success" disabled={this.state.error || !this.state.loaded}>Verify</Button>
                        </Modal.Footer>
                    </Form>
                </Modal >
            </React.Fragment >)
    }
}

export default ModalAuthentication;


// WEBPACK FOOTER //
// ./src/fw/modals/authentication/Authentication.js